import { useMemo, useState } from 'react';

const CUSTOM = '__custom__';

function enumOptions(f) {
  return (f.values || []).map((v) => ({
    code: String(v.code ?? v),
    label: v.label?.ru ?? v.label ?? String(v.code ?? v),
  }));
}

export default function FeatureFields({ features, attributes, onChange }) {
  const [customOpen, setCustomOpen] = useState({});

  const setVal = (code, v) => onChange({ ...attributes, [code]: v });

  const knownCodes = useMemo(() => {
    const map = {};
    (features || []).forEach((f) => {
      map[f.code] = new Set(enumOptions(f).map((o) => o.code));
    });
    return map;
  }, [features]);

  function renderInput(f) {
    const val = attributes[f.code];

    if (f.type === 'enum') {
      const opts = enumOptions(f);
      const known = knownCodes[f.code] || new Set();
      const isKnown = val === '' || val == null || known.has(String(val));
      const useCustom = Boolean(customOpen[f.code]) || (!isKnown && val != null && val !== '');
      const selectValue = useCustom ? CUSTOM : (val ?? '');
      const customText = useCustom && val !== CUSTOM ? String(val ?? '') : (customOpen[f.code] ? String(val ?? '') : '');

      return (
        <div className="pc-feature__control">
          <select
            value={selectValue}
            onChange={(e) => {
              const next = e.target.value;
              if (next === CUSTOM) {
                setCustomOpen((s) => ({ ...s, [f.code]: true }));
                setVal(f.code, '');
                return;
              }
              setCustomOpen((s) => ({ ...s, [f.code]: false }));
              setVal(f.code, next);
            }}
          >
            <option value="">— не указано</option>
            {opts.map((o) => (
              <option key={o.code} value={o.code}>{o.label}</option>
            ))}
            <option value={CUSTOM}>+ Своё значение</option>
          </select>
          {useCustom && (
            <input
              className="pc-feature__custom"
              value={customText}
              placeholder="Введите своё значение"
              autoFocus
              onChange={(e) => setVal(f.code, e.target.value)}
            />
          )}
        </div>
      );
    }

    if (f.type === 'number') {
      return (
        <input
          type="number"
          value={val ?? ''}
          min={f.min ?? undefined}
          max={f.max ?? undefined}
          step={f.step ?? 'any'}
          placeholder="не указано"
          onChange={(e) => setVal(f.code, e.target.value === '' ? '' : Number(e.target.value))}
        />
      );
    }

    if (f.type === 'bool') {
      const selectVal = val === true || val === 'true' ? 'true'
        : val === false || val === 'false' ? 'false'
          : '';
      return (
        <select
          value={selectVal}
          onChange={(e) => {
            const next = e.target.value;
            if (next === '') setVal(f.code, '');
            else setVal(f.code, next === 'true');
          }}
        >
          <option value="">— не указано</option>
          <option value="true">Да</option>
          <option value="false">Нет</option>
        </select>
      );
    }

    return (
      <input
        value={val ?? ''}
        placeholder="не указано"
        onChange={(e) => setVal(f.code, e.target.value)}
      />
    );
  }

  if (!features?.length) {
    return (
      <p className="pc-help">Для этой подкатегории особенности ещё не заданы.</p>
    );
  }

  return (
    <div className="pc-features">
      {features.map((f) => (
        <label key={f.code} className="pc-feature">
          <span>{f.name?.ru || f.code}{f.unit ? `, ${f.unit}` : ''}</span>
          {renderInput(f)}
        </label>
      ))}
    </div>
  );
}
